<!-- Content -->
@if (slideAuthorFacade.currentSelectedSlideAnnotation$ | async; as annotation) {
  <div
    class="flex flex-column align-items-center">
    <!-- Groups -->
    @if (slideAuthorFacade.groupIdsByAnnotation$(annotation.id) | async; as groupIds) {
      <medsurf-design-input-multi-select
        [name]="'annotation_groups'"
        [label]="'global.groups'"
        [model]="groupIds"
        [options]="(slideAuthorFacade.currentSelectedSlideGroupsArray$ | async) || []"
        [class]="'w-full'"
        [labelIcon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.GROUP"
      (valueChange)="onChange($event)"></medsurf-design-input-multi-select>
    }
  </div>
}
